import { paperClasses } from '@mui/material/Paper';
import { alpha } from '@mui/material/styles';

import { menuItemClasses } from '@mui/material/MenuItem';
import { listItemIconClasses } from '@mui/material/ListItemIcon';
import { iconButtonClasses } from '@mui/material/IconButton';
import { checkboxClasses } from '@mui/material/Checkbox';
import { listClasses } from '@mui/material/List';
import { gridClasses } from '@mui/x-data-grid';
import { tablePaginationClasses } from '@mui/material/TablePagination';
import { gray, brand } from '../themePrimitives';

export const dataGridCustomizations = {
  MuiDataGrid: {
    styleOverrides: {
      root: ({ theme }) => ({
        '--DataGrid-overlayHeight': '125px',
        overflow: 'clip',
        borderColor: theme.palette.divider,
        backgroundColor: theme.palette.background.default,
        [`& .${gridClasses.columnHeader}`]: {
          backgroundColor: brand[400],
          color: 'white',
          border: '0px',
          height: '40px !important',
        },
        ['& .align-right .MuiDataGrid-columnHeaderTitleContainer']: {
          justifyContent: 'flex-end!important;',
        },
        ['& .no-separator']: {
          '&:after': {
            content: 'none',
          },
        },
        ['& .no-separator .MuiDataGrid-columnSeparator']: {
          display: 'none',
        },
        [`& .MuiDataGrid-iconSeparator`]: {
          height: '15px',
        },
        [`& .${gridClasses.footerContainer}`]: {
          backgroundColor: theme.palette.background.paper,
        },
        [`& .${checkboxClasses.root}`]: {
          padding: theme.spacing(0.5),
          '& > svg': {
            fontSize: '1rem',
          },
        },
        [`& .${gridClasses.menuIconButton}`]: {
          color: 'white',
        },
        [`& .${gridClasses.menuIconButton}:hover`]: {
          backgroundColor: alpha(theme.palette.common.white, 0.1),
        },
        [`& .${gridClasses.iconButtonContainer} .MuiIconButton-root`]: {
          color: 'white',
        },
        [`& .${gridClasses.iconButtonContainer} .MuiIconButton-root:hover`]: {
          backgroundColor: alpha(theme.palette.common.white, 0.1),
        },
        [`& .${tablePaginationClasses.root}`]: {
          marginRight: theme.spacing(1),
          '& .MuiIconButton-root': {
            maxHeight: 32,
            maxWidth: 32,
            '& > svg': {
              fontSize: '1rem',
            },
          },
        },
      }),
      cell: ({ theme }) => ({
        // borderTopColor: theme.palette.divider,
        borderTop: 'none',
        outline: 'none !important',
        border: 'none',
        // borderRight: '1px solid #f0f0f0',
        position: 'relative',

        '::after': {
          content: '""',
          position: 'absolute',
          right: 0,
          top: '25%', // Starts at 25% from the top
          height: '50%', // 50% of the cell height
          width: '1px', // Width of the separator
          backgroundColor: theme.palette.divider, // Color of the separator
        },

        // '&:focus': {
        //   outline: 'none',
        //   outlineOffset: 'none',
        //   border: 'none',
        // },
        // '& .MuiButtonBase-root': {
        //   outline: 'none',
        //   outlineOffset: 'none',
        //   border: 'none',
        // },
      }),
      menu: ({ theme }) => ({
        borderRadius: theme.shape.borderRadius,
        backgroundImage: 'none',
        [`& .${paperClasses.root}`]: {
          border: `1px solid ${theme.palette.divider}`,
        },
        [`& .${menuItemClasses.root}`]: {
          margin: '0 4px',
        },
        [`& .${listItemIconClasses.root}`]: {
          marginRight: 0,
        },
        [`& .${listClasses.root}`]: {
          paddingLeft: 0,
          paddingRight: 0,
        },
      }),
      row: ({ theme }) => ({
        '&:last-of-type': {
          borderBottom: `1px solid ${theme.palette.divider}`,
        },
        '&:hover': {
          backgroundColor: theme.palette.action.hoverDark,
        },
        '&.Mui-selected': {
          background: theme.palette.action.selected,
          '&:hover': {
            backgroundColor: theme.palette.action.hoverDark,
          },
        },
        '&.even': {
          backgroundColor: theme.palette.background.default,
        },
        '&.odd': {
          backgroundColor: theme.palette.action.hover,
          '&:hover': {
            backgroundColor: theme.palette.action.hoverDark,
          },
        },
      }),
      iconButtonContainer: ({ theme }) => ({
        [`& .${iconButtonClasses.root}`]: {
          border: 'none',
          backgroundColor: 'transparent',
          '&:hover': {
            backgroundColor: alpha(theme.palette.action.selected, 0.3),
          },
          '&:active': {
            backgroundColor: gray[200],
          },
          ...theme.applyStyles('dark', {
            color: gray[50],
            '&:hover': {
              backgroundColor: gray[800],
            },
            '&:active': {
              backgroundColor: gray[900],
            },
          }),
        },
      }),
      menuIconButton: ({ theme }) => ({
        border: 'none',
        backgroundColor: 'transparent',
        '&:hover': {
          backgroundColor: gray[100],
        },
        '&:active': {
          backgroundColor: gray[200],
        },
        ...theme.applyStyles('dark', {
          color: gray[50],
          '&:hover': {
            backgroundColor: gray[800],
          },
          '&:active': {
            backgroundColor: gray[900],
          },
        }),
      }),
      filterForm: ({ theme }) => ({
        gap: theme.spacing(1),
        alignItems: 'flex-end',
      }),
      columnsManagementHeader: ({ theme }) => ({
        paddingRight: theme.spacing(3),
        paddingLeft: theme.spacing(3),
      }),
      columnHeaderTitleContainer: {
        flexGrow: 1,
        justifyContent: 'space-between',
      },
      columnHeaderDraggableContainer: { paddingRight: 2 },
    },
  },
};
